"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataStore = (function () {
    function DataStore(json) {
        this.json = json;
    }
    DataStore.prototype.getAllStates = function () {
        var states = this.json.states;
        return states.map(function (s) {
            return { value: s.name, name: s.name };
        });
    };
    DataStore.prototype.getAdvisorsArray = function (campusName) {
        var json = this.json;
        if (json.campuses) {
            for (var i = 0; i < json.campuses.length; i++) {
                if (json.campuses[i].name == campusName) {
                    return json.campuses[i].advisors;
                }
            }
        }
        console.log("Warning! No advisers found for campus=" + campusName);
        return null;
    };
    Object.defineProperty(DataStore.prototype, "programs", {
        get: function () {
            var json = this.json;
            var programs = [];
            if (json.programs) {
                programs = json.programs;
                programs.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
            return programs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "campuses", {
        get: function () {
            var json = this.json;
            var campuses = [];
            if (json.campuses) {
                campuses = json.campuses;
                campuses.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
            return campuses;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "marital_status", {
        get: function () {
            return [
                { value: "Married", name: "Married" },
                { value: "Single", name: "Single" },
                { value: "Divorced", name: "Divorced" },
                { value: "Widow", name: "Widow" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "gender", {
        get: function () {
            return [
                { value: "Male", name: "Male" },
                { value: "Female", name: "Female" },
                { value: "Other", name: "Non-Binary" },
                { value: "None", name: "Prefer Not To Disclose" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "schedules", {
        get: function () {
            return [
                { name: "Part time schedule", value: "Part time schedule" },
                { name: "Full time schedule", value: "Full time schedule" },
                { name: "Night time schedule", value: "Night time schedule" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    return DataStore;
}());
exports.DataStore = DataStore;
//# sourceMappingURL=data:application/json;base64,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